import { Col, Modal, Row } from 'antd';
import React, { useEffect } from 'react';
import { OPERATIONS } from '../../../common/constants';

export default function ConfirmEmptyValuesModal({
  visible,
  setVisible,
  setTwoFaModalVisible,
  setActionId,
  setActionKey,
  selectedItemName,
  nullValueKeys,
  actionKey,
  setExportEnvKeysModalOpen,
  setDuplicateValuesModalOpen,
  duplicateKeys,
}) {
  const handleOk = () => {
    if (duplicateKeys?.length > 0) {
      setVisible(false);
      setDuplicateValuesModalOpen(true);
    } else {
      setVisible(false);
      if (actionKey === OPERATIONS?.VERIFY_ENV) {
        setTwoFaModalVisible(true);
      } else {
        setExportEnvKeysModalOpen(true);
      }
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event?.key === 'Enter' && visible) {
        event?.preventDefault();
        handleOk();
      }
    };

    // eslint-disable-next-line no-undef
    document?.addEventListener('keydown', handleKeyDown);
    return () => {
      // eslint-disable-next-line no-undef
      document?.removeEventListener('keydown', handleKeyDown);
    };
  }, [visible]);

  return (
    <Modal
      open={visible}
      width={1000}
      centered
      title={
        <div className="d-flex" title={selectedItemName}>
          Confirm empty values before{' '}
          {actionKey === OPERATIONS?.VERIFY_ENV ? 'verify' : 'export'}
        </div>
      }
      onOk={() => handleOk()}
      onCancel={() => {
        setActionKey(null);
        setVisible(false);
        setActionId(null);
      }}
      okText="Yes, I am aware of Empty values."
      cancelText="No, Cancel"
    >
      <div className="pb-8">
        Are you sure you want to{' '}
        {actionKey === OPERATIONS?.VERIFY_ENV ? 'verify' : 'export'} '
        {selectedItemName}' ENV as it has empty values of keys:{' '}
      </div>
      <div className="scrollable-container">
        <Row gutter={[16, 8]}>
          {nullValueKeys?.map((keyName) => (
            <Col span={8} key={keyName}>
              <div className="p-8">{keyName}</div>
            </Col>
          ))}
        </Row>
      </div>
    </Modal>
  );
}
